<template>
<div id="ServiceCodePrereqServiceCodesAddEdit"> 
<form>  
<div class="form-group row my-1">

    <label for="SpecialistAmount" class="col-sm-4 label-small my-0">Service Code:</label>
        <div class="col-sm-4 my-0"> 
            <vue-bootstrap-typeahead ref="searchbox"  :disableSort=true  :data="ServiceCodes"  @hit="ServiceCodeChange(SelectedCode = $event)"  
                :serializer="item => item.servicedesc"  textVariant=".text-info"   placeholder="Search Service Code"  size="sm"  backgroundVariant="bg-light" :maxMatches="20" >
                <template slot="prepend">
                    <span class="input-group-text" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
                </template>                      
            </vue-bootstrap-typeahead> 
           <div v-show="this.codePrerequisite !=''"> {{this.codePrerequisite}} ({{this.serviceCodeDesc}})</div>
        </div>

    </div>
    <div class="form-group row" v-show="$v.codePrerequisite.$error" > 
        <small class="sml-red ml-3" v-if="!$v.codePrerequisite.required">Service Code is required</small>
        <small class="sml-red ml-3" v-if="!$v.codePrerequisite.Duplicate">Service Code already added</small>
        <small class="sml-red ml-3" v-if="!$v.codePrerequisite.isNotSameAs">Service Code can't be a prerequisite to itself</small>
    </div>

    <div class="form-group row my-1">
        <label for="codeUnitContradictory" class="col-sm-4 label-small my-0">Duration Unit:</label>
        <div class="col-sm-4 my-0">
            <select  id="codeUnitDelay"  v-model="codeUnitDelay"  class="mb-1 form-control form-control-sm"> 
                <option v-for="option  in DurationCodes" v-bind:value="{id: option.id,text:option.text}" :key="option.id" class="small">
                    {{ option.text }}
                </option> 
            </select>
        </div>
    </div>
     
     <div class="form-group row my-1">
    <label for="SpecialistAmount" class="col-sm-4 label-small my-0">Service Code Delay:</label>
    <div class="col-sm-4 my-0">
        <input id="SpecialistAmount"   maxlength="3" v-model="numUnitDelay" placeholder="Service Code Delay" class="mb-0 form-control form-control-xs">
    </div>
</div>

       <div class="form-group row" v-show="$v.numUnitDelay.$error" > 
         <small class="sml-red ml-3" v-if="!$v.numUnitDelay.required">Service Code Delay is required</small>
         <small class="sml-red ml-3" v-if="!$v.numUnitDelay.numeic && $v.numUnitDelay.required">Service Code Delay must be a number</small>
    </div>
<hr>
<div class="row" >
    <div class="col-sm-8" >
            <button v-on:click="SavePopup" :disabled="disableSave" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
    </div>
    <div class="col-sm-4">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
    </div>
</div>

</form>
</div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'

Vue.use(Vuelidate)
import { required, minLength, maxLength, between,withParams,email,numeric} from 'vuelidate/lib/validators'
import { notEqual } from 'assert'; 
export default {
    props:{
        UserData:'',
        Codes:'',
        mode:'',
        DataSet:'',
        UserRow:'',
        CurrentCode:''
    },
  data: function(){
    return{
        saveIcon:'fas fa-plus',
        btnName: 'Add Prerequisite Service Codes',
        numUnitDelay:'',
        codePrerequisite:'',
        serviceCodeDesc:'',
        succeeded:true,
        showModal:false,
        showModal:false,
        Msg:'',
        EditMode:'',
        disableSave:false,
        updateRow:{
          codePrerequisite:'',
          numUnitDelay:''
        },
        ServiceCodes:[], 
        SelectedCode:'',
        serviceids:[],
        tabledata:'',
        editedRow:'',
        serviceCode:'',
        DurationCodes:[]
    }   
  },
  created: function(){
      this.numUnitDelay = this.UserData.numUnitDelay;
      this.codePrerequisite = this.UserData.codePrerequisite==undefined?'':this.UserData.codePrerequisite;
      this.DurationCodes = [{id: 'D', text:'Days'},{id:'M', text:'Months'},{id:'Y', text:'Years'},{id:'L', text:'Lifetime'}];
      console.log( ' Unit code delay  before ' + this.UserData.codeUnitDelay )
      this.codeUnitDelay =this.UserData.codeUnitDelay==undefined?{id:'M',text:'Months'}: this.DurationCodes.find(x=>x.id== this.UserData.codeUnitDelay);
      console.log( ' Unit code delay  after ' + this.codeUnitDelay )
      this.EditMode = this.mode;
        console.log('code = '+ this.Codes)
      for(var i=0;i< this.Codes.length;i++){
            this.serviceids.push(this.Codes[i].id);
      }
        console.log(' service ids ' + this.serviceids)

      if(this.serviceids!=undefined > 0)
        this.GetServiceCodes();

      if(this.EditMode  == 'Edit')
      {
          this.btnName = 'Edit Prerequisite Service Codes';
          this.saveIcon = 'far fa-edit'; 
      } 

      this.tabledata = this.DataSet;
      this.editedRow = this.UserRow;
      this.serviceCode = this.CurrentCode;

  },





methods: {
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'ServiceCodePrereqServiceCodesAddEdit', '#btnShow') 
         //this.$v.$reset();
    },
    SavePopup: function(){
        console.log('before emit at pre req code unit delay is ' + this.codeUnitDelay.id);
       this.$v.$touch();
 
      if (!this.$v.$invalid){
          this.updateRow.codePrerequisite = this.codePrerequisite;
          this.updateRow.numUnitDelay =this.numUnitDelay;
          this.updateRow.codeUnitDelay = this.codeUnitDelay.id;
         
          this.$emit('PreReqUpdated', this.updateRow)
          this.showModal=false;
      }

      
    },
        GetServiceCodes(){ 
           var vm = this;
           var sc= vm.codePrerequisite.trim();
           var ids
            ids = this.serviceids.join();

            var params = new URLSearchParams();
            //alert(this.serviceids);
             params.append('ServiceID', ids);
             axios.get('SaskHealthApi/Codes/GetServiceCode', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             .then(function (response) {
                    vm.ServiceCodes =response.data; 
                })
            .catch(function (er) {
                console.log(er)
            }).then(function(){

                
                // var code = vm.ServiceCodes.find(x=>x.servicecode ==vm.codePrerequisite)
                console.log(' Sc  before setting up description ' + vm.codePrerequisite)
               if(vm.codePrerequisite!='')
               {
                    console.log(' have SC code ')
                   vm.serviceCodeDesc =  vm.ServiceCodes.find(x=>x.servicecode ==sc).servicedesc;
                   vm.codePrerequisite = sc;
                  
                   console.log(' SC description = ' + vm.serviceCodeDesc)
               }

            });
        },
        ServiceCodeChange(value){
            console.log('Service Code Change' + value);
            this.codePrerequisite = value.servicecode;
            this.serviceCodeDesc = value.servicedesc;
        }
},
  validations(){
    return {
        numUnitDelay:{
            required,
            numeric
        },
        codePrerequisite:{
            required,
            Duplicate: value=> this.tabledata.findIndex(x=>x.codePrerequisite == this.codePrerequisite)== -1 || this.tabledata.findIndex(x=>x.codePrerequisite == this.codePrerequisite) == this.editedRow,
            isNotSameAs: value=>this.codePrerequisite != this.serviceCode
        }
    }
  }
}
</script>

<style>

</style>
